import React from 'react';
import './sec1-about.css'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'

const Sec1about = ({ loading,}) => {


 const [headers, setheaders]= useState([]);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);




 const secRef = useRef(null);


useEffect(() => {
  if (loading) return;

  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, [loading]);








    return (
                <section className='sec1-containerp2' ref={secRef}>
                     <article className='sec1-sub-containerp3'>
                            <h1 className='header-herop2'>{headers?.[17]?.header}</h1>
                            <figure className='container-imgs-hero-about'>
                                <img className='left-img-hero-img-about' src={pic75} alt='exbibtion pic'></img>

                                <img className='center-hero-img-about' src={pic74} alt='exbibtion pic'></img>

                                 <img className='right-img-hero-img-about ' src={pic76} alt='exbibtion pic'></img>
                            </figure>
                    </article>
        
        
        
        
        
                </section>
    );
}
 
export default Sec1about;